export default __webpack_public_path__ + "static/media/temperature.d7b236c2.svg";